import { render, staticRenderFns } from "./TourWindow.vue?vue&type=template&id=ed1bc054&scoped=true&"
import script from "./TourWindow.vue?vue&type=script&lang=js&"
export * from "./TourWindow.vue?vue&type=script&lang=js&"
import style0 from "./TourWindow.vue?vue&type=style&index=0&id=ed1bc054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1bc054",
  null
  
)

export default component.exports